import { useAuth } from "@/contexts/AuthContext";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormEvent, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { LoginSchema } from "../schemas";
import { RoleEnum } from "@/types";
import { ROUTES } from "@/constants/routes";

const useLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
      rememberMe: false,
    },
    resolver: zodResolver(LoginSchema),
  });

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    handleSubmit(async (data) => {
      setIsSubmitting(true);
      try {
        const response = await login(
          data.email,
          data.password,
          data.rememberMe
        );
        if (response.success) {
          if (response.role === RoleEnum.OTHER) {
            navigate(ROUTES.CHAT);
            return;
          }
          navigate(ROUTES.E_LEARNING, { replace: true });
        }
      } catch (error) {
        console.error("Login error:", error);
      } finally {
        setIsSubmitting(false);
      }
    })();
  };

  return {
    register,
    errors,
    onSubmit,
    isLoading: isSubmitting,
    navigate,
    watch,
  };
};

export { useLogin };
